import React from 'react'
import PropTypes from 'prop-types'
import { Box, P, H5, Icon } from '@maui/elements'
import { cveColorTheme } from '../../../details/VulnerabilityDetails/colorMaps'
const BottomLabel = ({ children }) => (
  <P
    margin='0'
    color='colorTextDeemphasis'
    textStyle='caption'
    display='flex'
    alignItems='center'
    justifyContent='center'
    paddingTop='12px'
  >
    {children}
  </P>
)

const RatingsMatrix = ({ children }) => (
  <Box
    width='100%'
    height='100%'
    display='grid'
    gridTemplateColumns='repeat(5, 1fr)'
    gap='4px 4px'
    marginBottom='16px'
  >
    {children}
  </Box>
)

const SideLabel = ({ label }) => (
  <P
    display='flex'
    alignItems='center'
    justifyContent='end'
    paddingRight='12px'
    textStyle='caption'
    color='colorTextDeemphasis'
    textTransform='capitalize'
    margin='0'
  >
    {label}
  </P>
)

const Block = () => (
  <Box
    height='21px'
    width='84px'
    backgroundColor='colorFillMain'
  />
)

const ColoredBlock = ({ riskRating }) => (
  <Box
    height='21px'
    width='84px'
    backgroundColor={cveColorTheme.cve[riskRating]}
  />
)

const FadedBlock = ({ riskRating }) => (
  <Box
    height='21px'
    width='84px'
    backgroundColor={cveColorTheme.cve[riskRating]}
    opacity='0.2'
  />
)

export function RatingsMatrixTable({ ratings }) {
  const { exploitationState, riskRating: risk } = ratings
  const rows = ['wide', 'confirmed', 'available', 'anticipated', 'no known']
  const cols = ['low', 'medium', 'high', 'critical']
  const exploitRating = exploitationState ? exploitationState.toLowerCase() : 'no known'
  const riskRating = risk ? risk.toLowerCase() : ''

  return (
    <RatingsMatrix>
      {
        rows.map((row, i) => {
          return (
            <React.Fragment key={i}>
              <SideLabel label={row}/>
              {
                cols.map((col, j) => {
                  return (
                    <Box key={j}>
                      {exploitRating !== row && riskRating !== col && <Block /> }
                      {exploitRating === row && riskRating !== col && <FadedBlock riskRating={riskRating} />}
                      {exploitRating !== row && riskRating === col && <FadedBlock riskRating={riskRating} />}
                      {exploitRating === row && riskRating === col && <ColoredBlock riskRating={riskRating} />}
                    </Box>
                  )
                })
              }
            </React.Fragment>
          )
        })
      }
      <BottomLabel></BottomLabel>
      <BottomLabel>Low</BottomLabel>
      <BottomLabel>Medium</BottomLabel>
      <BottomLabel>High</BottomLabel>
      <BottomLabel>Critical</BottomLabel>
    </RatingsMatrix>
  )
}

RatingsMatrixTable.propTypes = {
  ratings: PropTypes.object,
}

export const RatingsPanel = ({ ratings = {}, zeroDay, inTheWild, variant }) => {
  if (!ratings) return null
  return (
    <Box>
      <H5>Exploitation State and Risk Rating</H5>
      {variant === 'priorityLabel' && (
        <Box display='flex' justifyContent='end'>
          <Box
            data-testid='priority-label'
            display='flex'
            justifyContent='center'
            borderColor='colorActionSecondary'
            borderWidth='1px'
            borderStyle='solid'
            borderBottomWidth='0px'
            mb='5px'
            pt='2px'
            width='172px'
          >
            <P textStyle='sectionLabel2' color='colorTextDisabled' margin='0'>
              highest priority
            </P>
          </Box>
        </Box>
      )}
      <RatingsMatrixTable ratings={ratings} />
      <Box mt='8px'>
        <Box display='flex' flexDirection='row'>
          <Box width='50%' >
            <P textStyle='sectionLabel1' margin='0' textAlign='center'>Zero Day?</P>
            <Box display='flex' alignItems='center' justifyContent='center' gap='4px'>
              {zeroDay && <Icon name='alertOctagonFill' color='colorRiskCritical' size='lg' />}
              <P textStyle='stats' margin='0'>{zeroDay ? 'Yes' : 'No'}</P>
            </Box>
          </Box>
          <Box>
            <Box width='1px' height='48px' backgroundColor='colorActionSecondary'/>
          </Box>
          <Box width='50%' textAlign='center'>
            <P textStyle='sectionLabel1' margin='0'>In the Wild?</P>
            <P textStyle='stats' margin='0'>{inTheWild ? 'Yes' : 'No'}</P>
          </Box>
        </Box>

      </Box>
    </Box>
  )
}

export default RatingsPanel

RatingsPanel.propTypes = {
  ratings: PropTypes.object,
  zeroDay: PropTypes.bool,
  inTheWild: PropTypes.bool
}
